module.exports = __webpack_public_path__ + "static/template_aqua-5bc90131f71c8046f92d59f7a5b10618.png";